import React from 'react';
import { useTranslation } from 'react-i18next';

const COINS = ['BTC', 'ETH', 'SOL'];

export function formatVolume(v) {
  if (v == null || isNaN(v)) return '$0';
  const abs = Math.abs(v);
  if (abs >= 1e9) return '$' + (v / 1e9).toFixed(1) + 'B';
  if (abs >= 1e6) return '$' + (v / 1e6).toFixed(1) + 'M';
  if (abs >= 1e3) return '$' + (v / 1e3).toFixed(0) + 'K';
  return '$' + v.toFixed(0);
}

function WhaleTradesPanel({ whaleSummary, coinStats, hours }) {
  const { t } = useTranslation();
  const totalLong = whaleSummary?.buyVolume || 0;
  const totalShort = whaleSummary?.sellVolume || 0;
  const totalAll = totalLong + totalShort || 1;

  const longPct = (totalLong / totalAll) * 100;
  const shortPct = (totalShort / totalAll) * 100;

  // Build coin rows with long/short from coinStats
  const coinRows = COINS.map((coin) => {
    const s = coinStats?.[coin];
    return {
      coin,
      long: s?.long || 0,
      short: s?.short || 0,
      total: (s?.long || 0) + (s?.short || 0),
    };
  });

  const maxCoinTotal = coinRows.reduce((m, c) => Math.max(m, c.total), 1);

  return (
    <div className="stats-panel stats-whale-panel">
      <div className="stats-panel-header">
        <span className="stats-panel-title">
          {hours}h {t('stats.whaleTrades')}
        </span>
      </div>

      <div className="stats-blk-total">
        <div>
          <div className="stats-lbl">{t('stats.total')}</div>
          <div className="stats-bt-val">{formatVolume(totalLong + totalShort)}</div>
        </div>
        <div className="stats-bt-split">
          <div className="stats-bts-row">
            <span className="stats-bts-lbl c-green">{t('stats.long')}</span>
            <div className="stats-bts-track">
              <div
                className="stats-bts-fill"
                style={{ width: `${longPct}%`, background: 'var(--green, #22c55e)', opacity: 0.65 }}
              />
            </div>
            <span className="stats-bts-num c-green">{formatVolume(totalLong)}</span>
          </div>
          <div className="stats-bts-row">
            <span className="stats-bts-lbl c-red">{t('stats.short')}</span>
            <div className="stats-bts-track">
              <div
                className="stats-bts-fill"
                style={{ width: `${shortPct}%`, background: 'var(--red, #ef4444)', opacity: 0.65 }}
              />
            </div>
            <span className="stats-bts-num c-red">{formatVolume(totalShort)}</span>
          </div>
        </div>
      </div>

      <div className="stats-coin-list">
        {coinRows.map((row) => {
          const lPct = (row.long / maxCoinTotal) * 100;
          const sPct = (row.short / maxCoinTotal) * 100;
          return (
            <div key={row.coin} className="stats-coin-row">
              <span className="stats-coin-nm">{row.coin}</span>
              <div className="stats-coin-bars">
                <div className="stats-cb-row">
                  <span className="stats-cb-lbl l">L</span>
                  <div className="stats-cb-track">
                    <div className="stats-cb-fill l" style={{ width: `${lPct}%` }} />
                  </div>
                  <span className="stats-cb-num">{formatVolume(row.long)}</span>
                </div>
                <div className="stats-cb-row">
                  <span className="stats-cb-lbl s">S</span>
                  <div className="stats-cb-track">
                    <div className="stats-cb-fill s" style={{ width: `${sPct}%` }} />
                  </div>
                  <span className="stats-cb-num">{formatVolume(row.short)}</span>
                </div>
              </div>
              <span className="stats-coin-tot">{formatVolume(row.total)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default WhaleTradesPanel;
